<template>
  <div style="height: 100%">
    <el-container style="height: 100%">
      <el-container>
        <el-header height="70px">
          <learn-header @click="unitOpen = !unitOpen" :book="book" :unit="unit" :type="type"></learn-header>
        </el-header>
        <el-main style="padding: 0">
          <learn-body :unit="unit" :type="type" @progressChange="(p)=>{progress = p}" @unitOver="unitOver"></learn-body>
        </el-main>
        <el-footer height="60px">
          <el-row class="foot-area">
            <el-col :span="4">正在学习: {{(progress!=null?progress.showCurrent:0)+1}}/{{progress!=null?progress.total:1}}</el-col>
            <el-col :span="3" :offset="11">熟词: {{progress!=null?progress.know.length:0}}</el-col>
            <el-col :span="3">夹生词: {{progress!=null?progress.unsure.length:0}}</el-col>
            <el-col :span="3">生词: {{progress!=null?progress.miss.length:0}}</el-col>
          </el-row>
        </el-footer>
      </el-container>
      <el-drawer
        :visible.sync="unitOpen"
        direction="rtl">
        <ul>
          <li @click="changeColumn(unit)" :style="{backgroundColor: unit.orders==unitNo?'#f7f7f7':'#fff'}" class="option" v-for="unit in unitLi" :key="unit.id">
            <span>{{unit.name}}</span>
          </li>
        </ul>
      </el-drawer>
    </el-container>
  </div>
</template>

<script>
import Header from './components/header'
import LearnBody from './components/learn-body'
import { mapGetters } from 'vuex'

export default {
  components: {
    'learn-header': Header,
    'learn-body': LearnBody,
  },
  computed: {
    ...mapGetters({
      info: 'getInfo',
    })
  },
  data() {
    return {
      baseApi: '/learn',
      trainApi: '/train',
      type: 'read',
      book: {},
      unit: {},
      unitNo: 0,
      unitOpen: false,
      unitLi: [],
      progress: null
    }
  },
  created() {
    this.type = this.$route.params.type;
    this.unitNo = this.$route.params.unitNo;
    this.book = this.$route.params.book;
    this.searchUnits()
  },
  methods: {
    searchUnits() {
      this.$fly.post(`${this.baseApi}/search-chapter`,{'bookNo.eLong': this.book.id,'asc': 'orders'}).then((res)=>{
        this.unitLi = res
        for (let i = 0; i < res.length; i++) {
          const item = res[i];
          if (this.unitNo == item.orders) {
            this.unit = item
            return
          }
        }
      })
    },
    changeColumn(unit) {
      this.unit = unit
      this.unitNo = unit.orders
      this.unitOpen = false
    },
    unitOver(map) {
      let current = this.unit
      let cur = JSON.parse(JSON.stringify(this.unit))
      let c = this.unitLi.indexOf(current)
      c = (c == this.unitLi.length-1?c:c+1)
      this.unit = this.unitLi[c]
      this.unitNo = this.unit.orders

      this.uploadLearn(map)
      this.$notify({
        title: '学习完成',
        message: '单词学习完成,即将进入课后练习...',
        position: 'bottom-right',
      });
      setTimeout(()=>{
        this.$router.push({
          name: '练习',
          params: {
            'name': `${this.book.name} ${cur.name} 课后练习-${this.type=='read'?'认读':this.type=='listen'?'辩音':'拼写'}`,
            'type': this.type == 'read'?1:this.type == 'listen'?2:3,
            'questionCount': 300,
            'words': [cur.words],
          }
        })
      },3000)
    },
    uploadLearn(map) {
      map['bookId'] = this.book.id
      map['unitNo'] = this.unitNo
      map['userId'] = this.info.id
      map['type'] = this.type=='listen'?2:this.type=='write'?3:1
      this.$fly.post(`${this.baseApi}/save-learn-record`,map).then((res)=>{
        window.console.log(res);
      })
    }
  }
}
</script>

<style scoped>
.el-header, .el-footer {
  background-color: #334970ee;
  color: #fff;
  text-align: center;
  line-height: 60px;
}

.el-main {
  background-color: #e7eef8;
  color: #333;
  text-align: center;
  height: calc(100vh - 130px)
}
ul{
  padding: 0;
  background: #f8f8f8;
  height: 820px;
  overflow-y: auto;
  list-style-type: none;
}
ul li{
  padding: 20px;
  margin: 2px 0;
  background-color: #fff;
}
.foot-area{
  font-size: 1.3em
}
</style>
